import React from "react";

const InvoiceList = React.lazy(() => import("./InvoiceList"));
const InvoiceShow = React.lazy(() => import("./InvoiceShow"));
const InvoiceCreate = React.lazy(() => import("./InvoiceCreate"));
const InvoiceEdit = React.lazy(() => import("./InvoiceEdit"));

export default {
  list: InvoiceList,
  show: InvoiceShow,
  create: InvoiceCreate,
  edit: InvoiceEdit,
};
